module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "news-item",
    on: {
      "click": function($event) {
        return _vm.onToWebView()
      }
    }
  }, [_c('div', {
    staticClass: "news-top flex-between"
  }, [(!_vm.row) ? _c('div', {
    staticClass: "news-type"
  }, [_vm._v(_vm._s(_vm.row.cate_list[0].name))]) : _c('div', {
    class: _vm.row.type == 'pic' ? 'news-type-pic news-type' : 'news-type-video news-type'
  }, [_vm._v("资讯")]), _vm._v(" "), _c('div', {
    staticClass: "news-read-count"
  }, [_vm._v(_vm._s(_vm.row.views_count) + "阅读")])]), _vm._v(" "), _c('div', {
    staticClass: "news-main"
  }, [_c('div', {
    staticClass: "news-titel-box flex-start"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "new-title-right on-show-two"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.row.title) + "\n\t\t\t\t\t"), _c('img', {
    staticClass: "title-right-img",
    staticStyle: {
      "width": ".17rem",
      "height": ".12rem"
    },
    attrs: {
      "src": require("../../assets/images/other/icon-yinhao-2.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "3.25rem",
      "height": "2.91rem",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.25rem",
      "height": "2.91rem",
      "border-radius": ".16rem"
    },
    attrs: {
      "src": _vm.row.pic_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pics-length"
  }, [_vm._v(_vm._s(_vm.row.pics_url.length) + "张")]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "play-btn"
  }, [_c('img', {
    staticStyle: {
      "width": ".58rem",
      "height": ".58rem"
    },
    attrs: {
      "src": require("../../assets/images/other/icon-playbtn.png")
    }
  })]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-title-left"
  }, [_c('img', {
    staticStyle: {
      "width": ".17rem",
      "height": ".12rem"
    },
    attrs: {
      "src": require("../../assets/images/other/icon-yinhao-1.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71d43289","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/NewsItem.vue
// module id = 2459
// module chunks = 0